import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: mocking-mike
 * id A24C1161-73F2-43F0-B955-7D4E5F398372
 * name text-box-check-outline
 * version: 3.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/text-box-check-outline.svg
 * tags
 * - Files / Folders 
 */
export const TextBoxCheckOutlineIcon = createSvgIcon(<><path d="M17,21L14.25,18L15.41,16.84L17,18.43L20.59,14.84L21.75,16.25M12.8,21H5C3.89,21 3,20.11 3,19V5C3,3.89 3.89,3 5,3H19C20.11,3 21,3.89 21,5V12.8C20.39,12.45 19.72,12.2 19,12.08V5H5V19H12.08C12.2,19.72 12.45,20.39 12.8,21M12,17H7V15H12M14.68,13H7V11H17V12.08C16.15,12.22 15.37,12.54 14.68,13M17,9H7V7H17" /></>, 'TextBoxCheckOutlineIcon');
export default TextBoxCheckOutlineIcon